import "./utils/appInit";
import React from "react";
import ReactDOM from "react-dom/client";
import JavascriptTimeAgo from "javascript-time-ago";

import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";

import App from "./App";
import ScrollToTop from "./components/ScrollToTop";
import "./assets/styles/style.css";
import { Cookies } from "react-cookie";
import registerServiceWorker from "./registerServiceWorker";

// The desired locales.
import en from "javascript-time-ago/locale/en";
import ru from "javascript-time-ago/locale/ru";
import { ImportProvider } from "./Context/ImportContext";
import ImportDataPolling from "./Polling/ImportDataPolling";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { registerLicense } from "@syncfusion/ej2-base";

registerLicense(process.env.REACT_APP_SYNCFUSION_LICENSE_KEY);
// Initialize the desired locales.
JavascriptTimeAgo.locale(en);
JavascriptTimeAgo.locale(ru);
const cookies = new Cookies();
const userFromCookies =
  cookies.get("authUser", { path: "/", secure: true }) || {};
const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

root.render(
  <BrowserRouter>
    <ImportProvider>
      <CookiesProvider>
        <ScrollToTop>
          <ImportDataPolling user={userFromCookies} />
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </ScrollToTop>
      </CookiesProvider>
    </ImportProvider>
  </BrowserRouter>
  // document.getElementById("root")
);

registerServiceWorker();
